export default __webpack_public_path__ + "static/media/17407 - Danny Greene.f6bdcc64.jpeg";